import { KeywordSuggestionsResponseSchema } from './schema';
import type { KeywordSuggestionsParams } from './schema';
import { HTTP_METHOD } from '../../consts';
import { serializeRequestBody } from '../../serializer';
import type { ApiCallOptions, Transport } from '../../types';

export const createSuggestionsApi = (transport: Transport) => ({
  getKeywordSuggestions: (params: KeywordSuggestionsParams, options?: ApiCallOptions) =>
    transport('/data/v1/suggestions/keywords', {
      method: HTTP_METHOD.POST,
      body: serializeRequestBody({ ...params }),
      deserializer: KeywordSuggestionsResponseSchema,
      signal: options?.signal
    })
});

export type SuggestionsApi = ReturnType<typeof createSuggestionsApi>;
